import React, {useState} from 'react';
import './Products.css'
// import { name } from 'tar/lib/types';
import { Link } from 'react-router-dom';
import { useNavigate  } from "react-router-dom";
import { motion } from 'framer-motion'; // Import Framer Motion

export default function Products(props) {
  const { id, name, title, imageUrl, price, discountPrice, addToCart, quantity, onAddToCart  } = props;
  const [hovered, setHovered] = useState(false);

  const isInStock = quantity > 0;
  const handleAddToCartClick = () => {
    if (!isInStock) {
      alert("This product is OUT OF STOCK. So you cannot ADD TO CART and BUY this product. Thanks.");
    } else {
      addToCart({ id, imageUrl, name, title, price, discountPrice });
      onAddToCart(); // Open the cart drawer
    }
  };
  const navigate = useNavigate();
  const handleProductClick = (Id) => {
    navigate(`/product_detail/${Id}`); // Navigate to the product detail page with the specific product ID
  };


  return (
    <>
      <motion.div 
      onClick={() => handleProductClick(id)}
      className="card"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      whileHover={{ scale: 1.05 }} // Scale up on hover
      whileTap={{ scale: 0.95 }} // Scale down on tap
      initial={{ opacity: 0, y: 20 }} // Initial animation state
      animate={{ opacity: 1, y: 0 }} // Animate to visible state
      transition={{ duration: 0.3 }} // Animation duration
      >
        {/* <Link to={`/product_detail/${id}`} className='card-product-Detail-Link'> */}
          <motion.img  
            // src={imageUrl[0]} 
            src={hovered ? imageUrl[1] : imageUrl[0]} 
            alt="product image" 
            className="card-product-image"
            whileHover={{ scale: 1.1 }} // Scale image on hover
            transition={{ duration: 0.3 }}
          />
          <h2 className="card-product-name">{title}</h2>
          {/* <h2 className="card-product-name">{name}</h2> */}
        {/* </Link> */}
        {/* <p className="card-product-price">Rs.{price}</p> */}
        <div>
            {discountPrice && discountPrice > 0 ? (
              <>
                <p className="card-product-price">
                  Rs. {price}
                </p>
                <p className="card-product-discount-price">
                  Rs. {discountPrice}
                </p>
              </>
            ) : (
                  <p className="card-product-discount-price">Rs.{price}</p>
                )}
          </div>
        <motion.button className='card-add-to-card-button' 
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering the product click event
                    handleAddToCartClick(); // Scale button on tap
                  }}
                  whileHover={{ scale: 1.1 }} // Scale button on hover
          whileTap={{ scale: 0.9 }} // Scale button on tap
          >
                  {/* onClick={handleAddToCartClick} */}
              Add to Cart
            </motion.button>
      </motion.div>
    </>
  );
}
